'use strict';

const Ajax = require('common/infra/ajax');

class API {
    _buildAnnouncementPath(announcementID) {
        return `/api/feedback/announcements/${announcementID}`;
    }

    fetchByID(announcementID) {
        const path = this._buildAnnouncementPath(announcementID);
        return Ajax.GET(path);
    }

    fetchPublished(limit=10, cursor=null) {
        const path = `/api/feedback/announcements`;
        let params = new URLSearchParams();

        params.append('limit', limit);
        if (cursor) {
            params.append('cursor', cursor);
        }

        return Ajax.GET(`${path}?${params.toString()}`);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./feedback/infra/api/announcement.js